import React, { useMemo } from 'react';

import DataGrid from '@gogame/data-grid';
import {
  useScreenTitle,
  useScreenDispatch,
  useScreenState,
} from '@gogame/screens';

import { useLoadRegsStatsTable } from 'scenes/RegsStats/data';
import {
  REORDER_COLUMNS,
  COLLAPSE_COLUMNS,
  SET_TABLE_SETTINGS,
} from 'scenes/RegsStats/reducers/regsStatsReducer';

import Toolbar from './Toolbar';

const getRegsStatsRowId = ({ 0: id }) => id;

const RegsStatsDataTable = () => {
  const [screenTitle] = useScreenTitle();
  const dispatch = useScreenDispatch();
  const screenState = useScreenState();
  const {
    filters,
    tableSettings,
    columns: { order },
    ready,
  } = screenState;

  const { data, isLoading, isRefetching } = useLoadRegsStatsTable(
    {
      filters,
      tableSettings,
      columns: { order },
    },
    {
      enabled: ready,
    }
  );

  const handleChangeSettings = (settings) => {
    dispatch({
      type: SET_TABLE_SETTINGS,
      payload: settings,
    });
  };

  const handleCollapse = (collapsed) => {
    dispatch({
      type: COLLAPSE_COLUMNS,
      payload: collapsed,
    });
  };

  const handleReorder = (order) => {
    dispatch({
      type: REORDER_COLUMNS,
      payload: order,
    });
  };

  const columnsIgnoredInExport = useMemo(() => {
    return data?.cols.reduce(
      (acc, { displayName, ignoredInExport }) =>
        ignoredInExport ? [...acc, { name: displayName }] : acc,
      []
    );
  }, [data?.cols]);

  return (
    <DataGrid
      rows={data?.rows}
      count={data?.count}
      title={screenTitle}
      loading={isLoading}
      fetching={isRefetching}
      ready={ready}
      onChangeSettings={handleChangeSettings}
      onReorder={handleReorder}
      onCollapse={handleCollapse}
      tableSettings={screenState.tableSettings}
      columnsState={screenState.columns}
      toolbar={<Toolbar columnsIgnoredInExport={columnsIgnoredInExport} />}
      storageKey={'regs-stats'}
      defaultColumnWidth={160}
      getRowId={getRegsStatsRowId}
    >
      {data?.cols.map(({ id, displayName, type }) => {
        const regActionIdColumn = id === '0';
        return (
          <DataGrid.Column
            key={id}
            field={id}
            type={type?.toLowerCase()}
            headerName={displayName}
            disableReorder={regActionIdColumn}
            unordered={regActionIdColumn}
            template={'LLL'}
            timeZone={'local'}
          />
        );
      })}
    </DataGrid>
  );
};

export default RegsStatsDataTable;
